import CTAButton from "components/CTAButton";
import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const Button = styled(CTAButton)`
  height: 36px;
  padding: 0 24px;
  font-size: 14px;

  ${mediaMin.sm`
    height: 40px;
    padding: 0 32px;
  `}
`;

export function SignUpButton({ onClick }: { onClick?: () => void }) {
  return (
    <NavLink to="/signup">
      <Button type="button" onClick={onClick}>
        Sign Up
      </Button>
    </NavLink>
  );
}
